// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1XcW4","right":"styles_right__32U02"};